import axiosInstance from "./axios";

export class DocenteService {
    /**
     * Obtiene la lista de docentes
     * @param {string} params
     */
    getDocentes(params = "") {
        return axiosInstance
            .get(`/docente${params.length ? `?${params}` : ""}`)
            .then((res) => res.data)
    }

    /**
     * Agrega un nuevo docente
     * @param {Object} dto
     */
    addDocente(dto) {
        return axiosInstance
            .post(`/docente`, dto)
            .then((res) => res.data)
    }

    /**
     * Actualiza un docente existente
     * @param {Object} dto
     */
    updateDocente(dto) {
        return axiosInstance
            .put(`/docente/${dto._id}`, dto)
            .then((res) => res.data)
    }

    /**
     * Sube una imagen de un docente
     * @param {string} id
     * @param {Object} obj
     */
    uploadImagenDocente(id, obj) {
        return axiosInstance
            .post(`/docente/upload/${id}`, obj)
            .then((res) => res.data)
    }

    /**
     * Obtiene la URL de la imagen de un docente
     * @param {string} id
     */
    getUrlImagen(id) {
        return `/docente/getupload/${id}`;
    }
}
